import { getFunnelUrl } from "./getFunnelUrl";

export { getFunnelUrl };
